<template>
  <div>
    <!--
    <v-data-table
      :headers="headers"
      :items="desserts"
      :items-per-page="5"
      class="elevation-1"
    ></v-data-table>
    -->

    <v-card class="ma-2">
      <v-card-title  class="teal white--text">
        Daftar Pengguna Internal
        <v-spacer />
        <v-btn  @click.stop="dlgUserAdd">
          <v-icon left>add</v-icon>
          Tambah
        </v-btn>
      </v-card-title>

      <v-card-title>
        <v-text-field v-model="table.search" prepend-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-card-title>

      <v-data-table
          class="elevation-1"
          :search="table.search"
          :headers="table.headers"
          :items="pos3List"
          :items-per-page="10"
          :single-select="true"
          item-key="id"
          height="400"
            fixed-header
      >
          <template v-slot:item.divisi="{item}">
            {{ getValueItem(itemsDivisi, item.divisi) }}
          </template>
          <template v-slot:item.roles="{item}">
            {{ getValueItem(itemsUserRoles, item.roles) }} 
          </template>
          <template v-slot:item.status="{item}">
            <v-chip class="" :color="getColor(item.status)" small>{{ getValueItem(itemsUserStatus, item.status) }}</v-chip>
          </template>
          <template v-slot:item.actions="{item}">
            <v-btn icon color="cyan" @click="openFormResetPassword(item)"> <v-icon>mdi-account-key</v-icon> </v-btn>
            <v-btn icon color="cyan" @click="openFormChangeStatus(item)"> <v-icon>mdi-account-check</v-icon> </v-btn>
          </template>
      </v-data-table>

      <v-dialog v-model="dlgResetPassword" max-width="400px" persistent>
        <v-card dark>
          <v-card-title>KIRIM RESET PASSWORD</v-card-title>
          <v-card-text>User ID: {{userResetPassword.login}}</v-card-text>
          <v-card-text>Nama: {{userResetPassword.nama}}</v-card-text>
          <v-card-text>Email: {{userResetPassword.email}}</v-card-text>
          <v-card-actions>
            <v-btn color="success" @click="submitFormResetPassword()">Kirim</v-btn>
            <v-btn color="orange" @click="dlgResetPassword = false">Batal</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dlgChangeStatus" max-width="400px" persistent>
        <v-card dark>
          <v-card-title>UBAH STATUS</v-card-title>
          <v-card-text>User ID: {{userChangeStatus.login}}</v-card-text>
          <v-card-text>Nama: {{userChangeStatus.nama}}</v-card-text>
          <v-card-text>Email: {{userChangeStatus.email}}</v-card-text>
          <v-container>
            <v-row>
              <v-col cols="5"><v-select v-model="userChangeStatus.status" :items="itemsUserStatus" label="Status" outlined></v-select></v-col>
            </v-row>
          </v-container>
          <v-card-actions>
            <v-btn color="success" @click="submitFormChangeStatus()">Simpan</v-btn>
            <v-btn color="orange" @click="dlgChangeStatus = false">Batal</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!--
      <v-card-text>
        <v-container class="">
          <v-row>
      -->
            <!-- <v-col cols=2 >
              <v-select
                :items="items"
                label="Jumlah Data"
                outlined
                dense
              > 
              </v-select>
            </v-col> -->
            <!--
            <v-col cols=3>
              <v-text-field
                label="Pencarian"
                name="email"
                type="text"
                outlined
                dense
                v-model="search"
                v-on:keyup.enter="doFilter"
              /> 
            </v-col>
            -->
            <!-- <v-col cols=7>
              <v-btn
                dark
                color="success"
                depressed
                @click.stop="dlgUser = true"
              >Tambah                    
              </v-btn>
            </v-col> -->
          <!--
          </v-row>
          <v-divider /> 
          <v-row class="green accent-2 px-2">  
            <v-col cols="2">
              <p class="subtitle-2">                      
                User ID / EMail
              </p>
            </v-col>                
            <v-col cols="3">
              <p class="subtitle-2">                      
                Nama
              </p>
            </v-col>
            <v-col cols="3">
              <p class="subtitle-2">                      
                Jabatan / Divisi
              </p>
            </v-col>
            <v-col cols="2">
              <p class="subtitle-2">                      
                Roles / Status
              </p>
            </v-col>
            <v-col cols="2">
              <p class="subtitle-2">                      
                -
              </p>
            </v-col>
          </v-row>
          <v-divider />
          <template v-if="pos3Count == 0">
            <v-row >
              <v-col cols="12" class="text-center">
                <p>TIDAK ADA DATA</p>
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <template v-for="item in pos3List">
              <v-row :key="item.id" class="px-2">
                <v-col cols="2" >                   
                    <div>
                    {{ item.login }} <br/>
                    {{ item.email }}
                    </div>
                </v-col>
                <v-col cols="3">
                  <div>{{ item.nama }}</div>
                </v-col>
                <v-col cols="3">
                  <div>
                    {{ item.jabatan }} <br/>
                    {{ getValueItem(itemsDivisi, item.divisi) }}
                    </div>
                </v-col>
                <v-col cols="2">
                  <div>
                    {{ getValueItem(itemsUserRoles, item.roles) }} <br/>
                    <v-chip
                      class=""
                      :color="getColor(item.status)"
                      small
                    >
                      {{ getValueItem(itemsUserStatus, item.status) }}
                    </v-chip>
                  </div>
                </v-col>
                <v-col cols="2">
                  <span v-if="isNonVendor(item.roles)"> 
                    <v-btn icon color="blue" @click="editUser(item.id)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </span>
                </v-col>
              </v-row>
              <v-divider :key="'A'+item.id"/>
            </template>
          </template>
          -->
          <!-- <v-row>
            <v-col cols="12">
              <v-btn color="success" dark @click.prevent="simpan3Click">
                Simpan & Lanjut
                <v-icon right large>arrow_right
                </v-icon>
              </v-btn>
            </v-col>
          </v-row> -->
        <!--
        </v-container>
      </v-card-text>
      -->
    </v-card>

    <v-dialog v-model="dlgUser" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dlgTitle }} User</span>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form3"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    label="User ID"
                    name="nomor"
                    type="text"
                    outlined
                    :rules=[minUserId]
                    v-model="login"
                  />                    
                  <v-text-field
                    label="E-Mail"
                    type="text"
                    outlined                    
                    :rules=[]
                    v-model="email"
                  />  
                  <v-select
                  :items="itemsUserRoles"
                  label="User Roles"
                  outlined
                  append-icon="check_circle"
                  v-model="roles"
                ></v-select>
                <v-select
                  :items="itemsUserStatus"
                  label="Status"
                  outlined
                  append-icon="check_circle"
                  v-model="status"
                  v-if="edit"
                ></v-select>
                <!-- <v-file-input
                  name="skPkp"
                  accept=".jpg,.png,.pdf"
                  label="SK Penunjukan"
                  chips
                  outlined
                />   -->
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    label="Nama"
                    type="text"
                    outlined                    
                    :rules=[]
                    v-model="nama"
                  />  
                  <v-text-field
                    label="Jabatan"
                    type="text"
                    outlined                    
                    :rules=[]
                    v-model="jabatan"
                  /> 
                  <v-select
                    :items="itemsDivisi"
                    label="Divisi"
                    outlined
                    append-icon="check_circle"
                    v-model="divisi"
                  ></v-select>
                </v-col>
              </v-row>              
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" dark @click="dlgUserClick">Simpan</v-btn>
          <v-btn color="orange" dark @click="dlgUser = false">Batal</v-btn>
          <v-btn color="info" dark @click="resetForm3" v-if="!edit">Reset</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="submitting" persistent max-width="300px">
        <v-card dark>
            <v-card-title>Sedang diproses</v-card-title>
            <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
        </v-card>
    </v-dialog>


  </div>
</template>

<script>
import { getValueItem, itemsUserRoles, itemsDivisi, itemsUserStatus } from "./../../lib/viewLib"
const apiUrl = process.env.VUE_APP_ROOT_API
import axios from 'axios'

export default {
  data: function() {
    return {
      edit: false,
      itemsUserRoles: itemsUserRoles,
      itemsDivisi: itemsDivisi,
      itemsUserStatus: itemsUserStatus,
      nonVendor: ['admin', 'user', 'PPKA', 'KPA', 'POKJA'],    
      search: '',  
      //
      id: -999,
      login: '',
      email: '',
      nama: '',
      nip: '',
      jabatan: '',
      divisi: '',
      telepon: '',
      roles: '',
      status: '',
      dlgUser: false,
      //pos3Count: 3,
      pos3List: [],
      valid: true,
      minPass: value => value.length >= this.$store.getters.PANJANG_MIN_PASSWD || `Password minimal ${this.$store.getters.PANJANG_MIN_PASSWD} karakter`,
      minUserId: value => value.length >= this.$store.getters.PANJANG_MIN_LOGIN || `User ID minimal ${this.$store.getters.PANJANG_MIN_LOGIN} karakter`,

      // Data table
      table: {
        search: "",
        headers: [
          { text: "User ID", value: "login", class: "green accent-2 subtitle-2" },
          { text: "Email", value: "email", class: "green accent-2 subtitle-2" },
          { text: "Nama", value: "nama", class: "green accent-2 subtitle-2" },
          { text: "Jabatan", value: "jabatan", class: "green accent-2 subtitle-2" },
          { text: "Divisi", value: "divisi", class: "green accent-2 subtitle-2" },
          { text: "Roles", value: "roles", class: "green accent-2 subtitle-2" },
          { text: "Status", value: "status", class: "green accent-2 subtitle-2" },
          { text: "", value: "actions", sortable: false, class: "green accent-2 subtitle-2" }
        ],
      },

      // Reset password
      dlgResetPassword: false,
      userResetPassword: {
        id: null,
        login: "",
        nama: "",
        email: ""
      },

      // Change status
      dlgChangeStatus: false,
      userChangeStatus: {
        id: null,
        login: "",
        nama: "",
        email: "",
        status: "I"
      },

      submitting: false,
    }
  },
  computed: {
    dlgTitle: function() { 
      return this.edit ? 'Ubah' : 'Tambah'
    }
  },
  methods: {
    doFilter: function() {
      this.pos3List = this.pos3List.filter(el => el.login.includes(this.search) || el.nama.includes(this.search))
    },
    resetForm3: function() {
      this.$refs.form3.reset() 
    },
    isNonVendor: function(roles) {
      return this.nonVendor.includes(roles)
    },
    openFormResetPassword: function(user) {
      if (user == null) return;

      this.dlgResetPassword = true;
      this.userResetPassword.id = user.id;
      this.userResetPassword.login = user.login;
      this.userResetPassword.nama = user.nama;
      this.userResetPassword.email = user.email;
    },
    submitFormResetPassword: async function() {
      if (this.userResetPassword.id == null) return;

      const data = {
        id: this.userResetPassword.id,
        userId: this.userResetPassword.login,
        email: this.userResetPassword.email
      };

      this.$store.dispatch('displayProgBar');  

      this.submitting = true;

      await axios.post(apiUrl + "/userman/forget", data)
      .then( () => {
        this.$store.dispatch('displayAlert', { color: 'success', message: `Ubah password berhasil dikirim` });
      })
      .catch( (err) => {
        console.error(err);
        this.$store.dispatch('displayAlert', { color: 'error', message: err });
      })
      .finally( () => {
        this.$store.dispatch('closeProgBar');
        this.submitting = false;
        window.scroll(0,0);
      });

      this.dlgResetPassword = false;
    },
    openFormChangeStatus: function(user) {
      if (user == null) return;

      this.dlgChangeStatus = true;
      this.userChangeStatus.id = user.id;
      this.userChangeStatus.login = user.login;
      this.userChangeStatus.nama = user.nama;
      this.userChangeStatus.email = user.email;
      this.userChangeStatus.status = user.status;
    },
    submitFormChangeStatus: async function() {
      if (this.userChangeStatus.id == null) return;

      this.$store.dispatch('displayProgBar')  
      this.submitting = true;

      await axios.put(apiUrl + "/userman/status/" + this.userChangeStatus.id, this.userChangeStatus)
      .then( () => {
        this.$store.dispatch('displayAlert', { color: 'success', message: `Ubah status user berhasil disimpan`});
        
        const index = this.pos3List.findIndex(element => element.id === this.userChangeStatus.id);
        if (index != -1) {
          this.pos3List[index].status = this.userChangeStatus.status;
        }
      })
      .catch( (err) => {
        console.error(err);
        this.$store.dispatch('displayAlert', { color: 'error', message: err });
      })
      .finally( () => {
        this.$store.dispatch('closeProgBar');
        this.submitting = false;
        window.scroll(0,0);
      });

      this.dlgChangeStatus = false;
    },
    editUser: function(id) {
      this.edit = true
      const el = this.pos3List.find(el => el.id === id)
      this.login = el.login
      this.email = el.email
      this.nama = el.nama
      this.nip = el.nip
      this.telepon = el.telepon
      this.jabatan = el.jabatan
      this.divisi = el.divisi
      this.roles = el.roles
      this.status = el.status
      this.id = el.id
      this.dlgUser = true
    },
    dlgUserAdd: function() {
      this.dlgUser = true
      this.edit = false
      this.$refs.form3.reset()     
    },
    dlgUserClick: async function() {
      if (!this.$refs.form3.validate()) return;
      
      const message = {
        id: null,
        login: this.login,
        email: this.email,
        nama: this.nama,
        jabatan: this.jabatan,
        nip: this.nip,
        telepon: this.telepon,
        divisi: this.divisi,
        roles: this.roles,
        status: this.status
      }
      if (!this.edit) {
        this.$store.dispatch('displayProgBar')  
        this.submitting = true;

        await axios.post(apiUrl+'/userman/register', message)
        .then((response) => {
          console.log(response)
          this.$store.dispatch('displayAlert', {
            color: 'success', 
            message: `Data user baru telah tersimpan !` })
          window.scroll(0,0)
          message.id = response.data.memberId
          message.status = response.data.memberStatus
          this.pos3List.push(message)
          //this.pos3Count = this.pos3List.length
          this.dlgUser = false
        })
        .catch((err) => {
          this.$store.dispatch('displayAlert', {color: 'error', message: err})
          window.scroll(0,0)
        })
        .finally(() => {
          this.$store.dispatch('closeProgBar');
          this.submitting = false;
        })  
      }
      else {
        message.id = this.id
        this.$store.dispatch('displayProgBar');
        this.submitting = true;

        await axios.put(apiUrl+'/userman/register', message)
        .then((response) => {
          console.log(response)
          this.$store.dispatch('displayAlert', {
            color: 'success', 
            message: `Data user telah diupdate !` })
          window.scroll(0,0)

          const idx = this.pos3List.findIndex(el => el.id === this.id)
          this.pos3List[idx] = message
          // message.id = response.data.memberId
          // this.pos3List.push(message)
          // this.pos3Count = this.pos3List.length
          this.dlgUser = false
        })
        .catch((err) => {
          this.$store.dispatch('displayAlert', {color: 'error', message: err})
          window.scroll(0,0)
        })
        .finally(() => {
          this.$store.dispatch('closeProgBar');
          this.submitting = false;
        })  
      }
    },
    getValueItem: getValueItem,
    getColor: function(status) {
      let color = ''
      switch (status) {
        case 'A':
          color = 'success'
          break
        case 'S': 
          color = 'warning'
          break
        case 'I':
          color = 'error'
          break
        default:
          color = 'primary'
      }
      return color
    }
  },
  created: async function() {
    /*
    await axios.get(apiUrl+'/userman/all')
    .then((response) => {
      if (response.data.statusCode != 200) {
        this.pos3List = []
      }
      else {
        response.data.data.rows.forEach(element => {          
          this.pos3List.push(element)
        })              
      }
      this.pos3Count = this.pos3List.length
    })
    .catch((error) => {
      console.log(error)
    })
    */
   
   await axios.get(apiUrl + "/userman/internal")
   .then( (response) => {
     this.pos3List = response.data;
   })
   .catch( (error) => {
     console.error(error);
   });

  }
}
</script>

<style>

</style>